import { type NodeViewProps } from '@tiptap/core';
import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';
import { useEffect, useRef, useState } from 'react';

const fontStyle: { [key: string]: string } = {
  h1: 'font-display-1',
  h2: 'font-display-2-editor',
  h3: 'font-display-3-editor',
  h4: 'font-display-4',
};

function hasNonEditableAncestor(element: HTMLElement | null): boolean {
  if (element == null) {
    return false;
  }

  let current = element.parentElement;
  while (current != null) {
    if (current.getAttribute('contenteditable') === 'false') {
      return true;
    }
    current = current.parentElement;
  }
  return false;
}

export function ContentHeadingView(props: NodeViewProps) {
  const { level, textAlign } = props.node.attrs;
  const headingLevel = `h${level ?? '1'}`;
  const fontClassName = fontStyle[headingLevel];
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [hasNonEditableParent, setHasNonEditableParent] = useState(false);

  useEffect(function checkAncestors() {
    setHasNonEditableParent(hasNonEditableAncestor(wrapperRef.current));
  }, []);

  return (
    <NodeViewWrapper
      ref={wrapperRef}
      className="group relative flex w-full items-start justify-end justify-self-center px-8"
    >
      <div
        className={`font-body-2-m absolute left-1 select-none text-branding-gray-600 ${hasNonEditableParent ? '' : 'group-hover:hidden'}`}
        contentEditable={false}
      >
        {headingLevel.toUpperCase()}
      </div>
      <NodeViewContent
        className={`${fontClassName} w-full max-w-[800px]`}
        style={textAlign == null ? {} : { textAlign: textAlign as string }}
      />
    </NodeViewWrapper>
  );
}
